// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overflow-y-scroll[data-v-ffbcad7c]{overflow-y:scroll}.d-flex-gap[data-v-ffbcad7c]{gap:30px}.legend-box[data-v-ffbcad7c]{width:30px;height:15px;background-color:#67961c}.legend-box-after-hour[data-v-ffbcad7c]{background-color:#7a0000}.legend-box-label[data-v-ffbcad7c]{font-size:.8em;margin-left:.5em}.tip-text[data-v-ffbcad7c]{font-weight:300;vertical-align:baseline;font-size:smaller}.timeline-paragraph-width[data-v-ffbcad7c]{max-width:1000px}", ""]);
// Exports
module.exports = exports;
